"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TimePickerInput = void 0;
const react_1 = __importDefault(require("react"));
const time_picker_1 = __importDefault(require("antd/lib/time-picker"));
const TIME_FORMAT = "h:mm a";
class TimePickerInput extends react_1.default.PureComponent {
  render() {
    const _a = this.props,
      _a$format = _a.format,
      format = _a$format === void 0 ? TIME_FORMAT : _a$format,
      inputProps = __rest(_a, ["format"]);
    return react_1.default.createElement(time_picker_1.default, Object.assign({
      format: format
    }, inputProps));
  }
}
exports.TimePickerInput = TimePickerInput;
exports.default = TimePickerInput;